export const SLIDER_POINTS = [
  {
    value: 12,
    isVisible: true,
  },
  {
    value: 24,
    isVisible: true,
  },
  {
    value: 36,
    isVisible: true,
  },
  {
    value: 48,
    isVisible: true,
  },
  {
    value: 60,
    isVisible: false,
  },
  {
    value: 72,
    isVisible: true,
  },
  {
    value: 100,
    isVisible: false,
  },
  {
    value: 144,
    isVisible: true,
  },
  {
    value: 150,
    isVisible: false,
  },
  {
    value: 288,
    isVisible: true,
    label: '+',
  },
];

export const AUTH_REQUIRED_COPY = {
  PRIMARY: 'Please log in to continue.',
  SECONDARY:
    'Your session may have expired. Log in through the main Fresh Prints app, then return here.',
};

export const ROUTES_WITHOUT_HEADER = ['/regular-order/new', '/store/new', '/store-checkout/new'];

export const isStoreCheckoutRoute = (pathname: string): boolean =>
  pathname === '/store-checkout/new' || /^\/store\/edit\/[^/]+$/.test(pathname);

export const PUBLIC_ROUTES = {
  INVOICE_PAYMENT: /\/pay\/invoice\/[0-9]+/,
};

/** Countdown unit labels. The `inline` timer spells units out inside copy strips. */
export const EXPIRATION_TIMER_UNIT_LABELS = {
  pill: { days: 'D', hours: 'H', minutes: 'M', seconds: 'S' },
  inline: { days: 'DAYS', hours: 'HRS', minutes: 'MIN', seconds: 'SEC' },
} as const;

export const COST_STAYS_THE_SAME = 'Cost stays the same';
export const COST_GOES_DOWN = 'Cost goes down as more people order';

export const GO_BREAKPOINTS_COST_STAYS_SAME = [
  {
    quantity: 12,
    price: 30,
    isMoreQuantity: false,
  },
  {
    quantity: 24,
    price: 28,
    isMoreQuantity: false,
  },
  {
    quantity: 36,
    price: 26,
    isMoreQuantity: false,
  },
  {
    quantity: 48,
    price: 24,
    isMoreQuantity: false,
  },
  {
    quantity: 72,
    price: 22,
    isMoreQuantity: false,
  },
  {
    quantity: 144,
    price: 20,
    isMoreQuantity: true,
  },
];

export const GO_BREAKPOINTS_COST_GOES_DOWN = [
  {
    quantity: 12,
    price: 30,
    isMoreQuantity: false,
  },
  {
    quantity: 24,
    price: 28,
    isMoreQuantity: false,
  },
  {
    quantity: 36,
    price: 26,
    isMoreQuantity: false,
  },
  {
    quantity: 48,
    price: 24,
    isMoreQuantity: false,
  },
  {
    quantity: 72,
    price: 22,
    isMoreQuantity: false,
  },
  {
    quantity: 144,
    price: 20,
    isMoreQuantity: false,
  },
];

/** Map for print type/deco methods variant images */
export const PRINT_DECO_IMAGES: Record<string, string> = {
  'screenprint:standard': 'screen_print_standard',
  'studs:neckline&arms': 'studs_neckline_arm',
};

/** To get the print type or deco methods respective variants image */
export const getPrintDecoImage = (
  printInfo: string,
  subPrintInfo: string | null
): string | null => {
  const printType = printInfo ? printInfo.toLowerCase().replace(/\s/g, '') : '';
  const printTypeVariant = subPrintInfo ? subPrintInfo.toLowerCase().replace(/\s/g, '') : '';
  const imageName = PRINT_DECO_IMAGES[`${printType}:${printTypeVariant}`];
  return imageName ? `/src/assets/svg/print-decor/${imageName}.svg` : null;
};

export const STORE_ORDER_EMAIL_FAILURE =
  'Failed to send store request. Contact hi@freshprints.com.';

export const PROMO_CODE_TYPES = {
  buyXGetY: 0,
  fixedAmount: 1,
  freeShipping: 2,
  percentage: 3,
  organizerPays: 4,
  noGuaranteeFee: 7,
};

export const PROMO_CODE_ERROR_MSG = 'Code says nope! Try again?';
export const PROMO_CODE_GUARANTEE_REQUIRED_MSG = 'Guarantee must be selected!';
export const SUBTOTAL_PROMO_CODE_ERROR_PREFIX = 'So close! Order';
